import React from "react";
import { useNavigate } from "react-router-dom";
import CardHorarios from "../CardHorarios";
import RoomInfo from "../RoomInfo";
import useMediaQuery from "../../hooks/useMediaQuery";
import "./styles.css";

const CardSala = ({ room, selectedDate, onClickSchedule }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/room/${room.id}`); // Navega para a rota da sala com o ID correto
  };

  return (
    <div className="room">
      {isMobile ? (
        <RoomInfo room={room} isMobile={true} onClick={handleClick} />
      ) : (
        <div>
          <RoomInfo room={room} isMobile={false} />
          <CardHorarios
            roomId={room.id} // Passa o ID da sala
            roomName={room.name}
            selectedDate={selectedDate} // Passa a data selecionada
            onClickSchedule={onClickSchedule}
          />
        </div>
      )}
    </div>
  );
};

export default CardSala;
